export enum AlertLevel {
  none = "None",
  low = "Low alert",
  medium = "Medium alert",
  high = "High alert",
}
